import { useEffect } from 'react';
import { doc, getDoc } from 'firebase/firestore';
import { useAuth } from '../context/AuthContext';
import { db } from '../lib/firebase';
import { commitUiLanguage } from './commitUiLanguage';
import { isUiLanguage, resolveUiLanguage, uiLanguageRevision } from './uiLanguage';

/**
 * ログイン後に users/{uid}.uiLanguage を表示言語へ反映する。
 * 未設定ならブラウザ言語。対応が無ければ英語。ブラウザ判定は DB に書き戻さない。
 */
export function UiLanguageSync() {
  const { user, initializing, stabilizing } = useAuth();
  const uid = user?.uid ?? null;

  useEffect(() => {
    if (initializing || stabilizing || !uid) return;

    const revision = uiLanguageRevision();
    let cancelled = false;

    void (async () => {
      try {
        const snap = await getDoc(doc(db, 'users', uid));
        if (cancelled || uiLanguageRevision() !== revision) return;
        const stored = snap.exists() ? snap.data()?.uiLanguage : null;
        if (!isUiLanguage(stored) && revision > 0) return;
        commitUiLanguage(resolveUiLanguage(stored));
      } catch (error) {
        console.warn('[UiLanguageSync] uiLanguage の読み込みに失敗しました', error);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [uid, initializing, stabilizing]);

  return null;
}
